import CircularProgress from '@mui/material/CircularProgress';

// TODO: add size prop and reuse everywhere
const ActivityIndicator = () => {
  return (
    <CircularProgress
      sx={{
        width: '50%',
        height: '50%',
        top: '25%',
        left: '25%',
        minHeight: 300,
        minWidth: 600,
      }}
    />
  );
};

export default ActivityIndicator;
